import {
  createRequestTypes,
  createActions,
} from 'app/store/actions/base-request.actions'

const GET_USER_DATA = createRequestTypes('[User Data] GET_USER_DATA')
const SET_USER_GRADE = createRequestTypes('[User Data] SET_USER_GRADE')

export const userDataActions = {
  GET_USER_DATA,
  SET_USER_GRADE,
}

export const userDataActionCreators = {
  getUserData: { ...createActions(GET_USER_DATA) },
  setUserGrade: { ...createActions(SET_USER_GRADE) },
}
